module.exports = __webpack_public_path__ + "img/M0070.a097b930.png";